export default __webpack_public_path__ + "static/media/CardHamam.5a4cfc71.jpg";